import jquery from "jquery";
window.jQuery = window.$ = jquery;

// Bootstrap Framework
import "./scss/index.scss";
import "@popperjs/core";
import "bootstrap";

import "slick-carousel";
import hcSticky from "hc-sticky";
import Plyr from "plyr";
import Swal from "sweetalert2/src/sweetalert2";
window.Swal = Swal;
import "select2";
import "select2/dist/css/select2.min.css";
import "select2-bootstrap-5-theme/dist/select2-bootstrap-5-theme.min.css";
import "jquery-match-height";
import "fit.js";
import fit from "fit.js";
//import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

//#region stickybar
document.addEventListener("DOMContentLoaded", function () {
  new hcSticky(".stickybar", {
    stickTo: "body",
    stickyClass: "stickybar--sticked",
  });
});
//#endregion

//#region slider
$(function () {
  $(".slider").slick({
    dots: true,
    arrows: false,
    fade: true,
    autoplay: true,
    autoplaySpeed: 10000,
  });
});
//#endregion

//#region video player
$(function () {
  const player = new Plyr("#videoPlayer", {
    ratio: "16:9",
  });
  player.on("ready", (event) => {
    fit(document.querySelector(".plyr"), document.querySelector(".video"), {
      hAlign: fit.CENTER,
      vAlign: fit.CENTER,
      watch: true,
    });
  });
  const player2 = new Plyr("#videoPlayer2"); 
});
//#endregion

//#region carousel
$(function () {
  $(".carousel").slick({
    dots: false,
    prevArrow: ".carousel__arrow--prev",
    nextArrow: ".carousel__arrow--next",
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: true,
    autoplaySpeed: 30000,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
});
//#endregion

//#region mobile shortcut
$(function () {
  $(".shortcut__close").on("click", function (e) {
    e.preventDefault();
    $(".shortcut").addClass("shortcut--close");
  });
});
//#endregion

//#region sidebar
$(function () {
  $(".sidebar__item--dropdown").each(function () {
    let $toggle = $(this).find("span > a:last-child").first();
    let $dropdown = $(this).find(".sidebar__dropdown").first();
    $toggle.on("click", function (e) {
      e.preventDefault();
      $dropdown.toggleClass("show");
    });
  });
});
//#endregion

//#region gallery
$(function () {
  $(".gallery__zoom").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    adaptiveHeight: true,
    asNavFor: ".gallery__thumb",
  });
  $(".gallery__thumb").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: ".gallery__zoom",
    focusOnSelect: true,
  });
});
//#endregion

//#region product box match height
$(function () {
  $(".product__box").matchHeight({
    byRow: true,
  });
});
//#endegion
